/* tslint:disable */
/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const createJobCard = /* GraphQL */ `
  mutation CreateJobCard(
    $input: CreateJobCardInput!
    $condition: ModeljobCardConditionInput
  ) {
    createJobCard(input: $input, condition: $condition) {
      id
      companyName
      jobNo
      impExp
      mode
      airlineName
      masterBLNo
      masterAWBNo
      houseBLNo
      houseAWBNo
      AWBDate
      AWBId
      shipperName
      shipperAddress01
      shipperAddress02
      shipperAddress03
      shipperAddress04
      consigneeName
      consigneeAddress01
      consigneeAddress02
      consigneeAddress03
      consigneeAddress04
      notifyName
      notifyAddress01
      notifyAddress02
      notifyAddress03
      notifyAddress04
      deliveryAgentName
      deliveryAgentAddress01
      deliveryAgentAddress02
      deliveryAgentAddress03
      deliveryAgentAddress04
      placeOfReceipt
      portOfLoading
      EtdAtPortOfLoading
      portOfDischarge
      finalPlaceOfDelivery
      EtaAtPortOfDischarge
      vesselVoy
      bookingAgentName
      bookingAgentAddress
      marksAndNumbers
      containerNo
      lineSealNo
      customSealNo
      typeOfContainer
      description
      netWeight
      grossWeight
      measurement
      chaName
      checkListNo
      checkListDate
      shippingBillNo
      shippingBillDate
      coLoader
      stuffingDate
      noOfPackages
      pallet
      palletNo
      certificate
      otherCertificateName
      insurance
      transportation
      specialInstructions
      editable
      RequestedDate
      accountId
      ownerEmail
      status
      type
      closeAt
      closeBy
      cancelAt
      cancelBy
      createdAt
      updatedAt
      owner
    }
  }
`;
export const updateJobCard = /* GraphQL */ `
  mutation UpdateJobCard(
    $input: UpdateJobCardInput!
    $condition: ModeljobCardConditionInput
  ) {
    updateJobCard(input: $input, condition: $condition) {
      id
      companyName
      jobNo
      impExp
      mode
      airlineName
      masterBLNo
      masterAWBNo
      houseBLNo
      houseAWBNo
      AWBDate
      AWBId
      shipperName
      shipperAddress01
      shipperAddress02
      shipperAddress03
      shipperAddress04
      consigneeName
      consigneeAddress01
      consigneeAddress02
      consigneeAddress03
      consigneeAddress04
      notifyName
      notifyAddress01
      notifyAddress02
      notifyAddress03
      notifyAddress04
      deliveryAgentName
      deliveryAgentAddress01
      deliveryAgentAddress02
      deliveryAgentAddress03
      deliveryAgentAddress04
      placeOfReceipt
      portOfLoading
      EtdAtPortOfLoading
      portOfDischarge
      finalPlaceOfDelivery
      EtaAtPortOfDischarge
      vesselVoy
      bookingAgentName
      bookingAgentAddress
      marksAndNumbers
      containerNo
      lineSealNo
      customSealNo
      typeOfContainer
      description
      netWeight
      grossWeight
      measurement
      chaName
      checkListNo
      checkListDate
      shippingBillNo
      shippingBillDate
      coLoader
      stuffingDate
      noOfPackages
      pallet
      palletNo
      certificate
      otherCertificateName
      insurance
      transportation
      specialInstructions
      editable
      RequestedDate
      accountId
      ownerEmail
      status
      type
      closeAt
      closeBy
      cancelAt
      cancelBy
      createdAt
      updatedAt
      owner
    }
  }
`;
export const deleteJobCard = /* GraphQL */ `
  mutation DeleteJobCard(
    $input: DeleteJobCardInput!
    $condition: ModeljobCardConditionInput
  ) {
    deleteJobCard(input: $input, condition: $condition) {
      id
      companyName
      jobNo
      impExp
      mode
      airlineName
      masterBLNo
      masterAWBNo
      houseBLNo
      houseAWBNo
      AWBDate
      AWBId
      shipperName
      shipperAddress01
      shipperAddress02
      shipperAddress03
      shipperAddress04
      consigneeName
      consigneeAddress01
      consigneeAddress02
      consigneeAddress03
      consigneeAddress04
      notifyName
      notifyAddress01
      notifyAddress02
      notifyAddress03
      notifyAddress04
      deliveryAgentName
      deliveryAgentAddress01
      deliveryAgentAddress02
      deliveryAgentAddress03
      deliveryAgentAddress04
      placeOfReceipt
      portOfLoading
      EtdAtPortOfLoading
      portOfDischarge
      finalPlaceOfDelivery
      EtaAtPortOfDischarge
      vesselVoy
      bookingAgentName
      bookingAgentAddress
      marksAndNumbers
      containerNo
      lineSealNo
      customSealNo
      typeOfContainer
      description
      netWeight
      grossWeight
      measurement
      chaName
      checkListNo
      checkListDate
      shippingBillNo
      shippingBillDate
      coLoader
      stuffingDate
      noOfPackages
      pallet
      palletNo
      certificate
      otherCertificateName
      insurance
      transportation
      specialInstructions
      editable
      RequestedDate
      accountId
      ownerEmail
      status
      type
      closeAt
      closeBy
      cancelAt
      cancelBy
      createdAt
      updatedAt
      owner
    }
  }
`;
export const createNextJobNo = /* GraphQL */ `
  mutation CreateNextJobNo(
    $input: CreateNextJobNoInput!
    $condition: ModelnextJobNoConditionInput
  ) {
    createNextJobNo(input: $input, condition: $condition) {
      id
      nextTVTJobNo
      nextTLIJobNo
      nextEGLJobNo
      createdAt
      updatedAt
      owner
    }
  }
`;
export const updateNextJobNo = /* GraphQL */ `
  mutation UpdateNextJobNo(
    $input: UpdateNextJobNoInput!
    $condition: ModelnextJobNoConditionInput
  ) {
    updateNextJobNo(input: $input, condition: $condition) {
      id
      nextTVTJobNo
      nextTLIJobNo
      nextEGLJobNo
      createdAt
      updatedAt
      owner
    }
  }
`;
export const deleteNextJobNo = /* GraphQL */ `
  mutation DeleteNextJobNo(
    $input: DeleteNextJobNoInput!
    $condition: ModelnextJobNoConditionInput
  ) {
    deleteNextJobNo(input: $input, condition: $condition) {
      id
      nextTVTJobNo
      nextTLIJobNo
      nextEGLJobNo
      createdAt
      updatedAt
      owner
    }
  }
`;
export const createBookingAgent = /* GraphQL */ `
  mutation CreateBookingAgent(
    $input: CreateBookingAgentInput!
    $condition: ModelbookingAgentConditionInput
  ) {
    createBookingAgent(input: $input, condition: $condition) {
      id
      name
      address
      type
      createdAt
      updatedAt
      owner
    }
  }
`;
export const updateBookingAgent = /* GraphQL */ `
  mutation UpdateBookingAgent(
    $input: UpdateBookingAgentInput!
    $condition: ModelbookingAgentConditionInput
  ) {
    updateBookingAgent(input: $input, condition: $condition) {
      id
      name
      address
      type
      createdAt
      updatedAt
      owner
    }
  }
`;
export const deleteBookingAgent = /* GraphQL */ `
  mutation DeleteBookingAgent(
    $input: DeleteBookingAgentInput!
    $condition: ModelbookingAgentConditionInput
  ) {
    deleteBookingAgent(input: $input, condition: $condition) {
      id
      name
      address
      type
      createdAt
      updatedAt
      owner
    }
  }
`;
export const createShipper = /* GraphQL */ `
  mutation CreateShipper(
    $input: CreateShipperInput!
    $condition: ModelshipperConditionInput
  ) {
    createShipper(input: $input, condition: $condition) {
      id
      name
      address01
      address02
      address03
      address04
      createdAt
      type
      updatedAt
      owner
    }
  }
`;
export const updateShipper = /* GraphQL */ `
  mutation UpdateShipper(
    $input: UpdateShipperInput!
    $condition: ModelshipperConditionInput
  ) {
    updateShipper(input: $input, condition: $condition) {
      id
      name
      address01
      address02
      address03
      address04
      createdAt
      type
      updatedAt
      owner
    }
  }
`;
export const deleteShipper = /* GraphQL */ `
  mutation DeleteShipper(
    $input: DeleteShipperInput!
    $condition: ModelshipperConditionInput
  ) {
    deleteShipper(input: $input, condition: $condition) {
      id
      name
      address01
      address02
      address03
      address04
      createdAt
      type
      updatedAt
      owner
    }
  }
`;
export const createConsignee = /* GraphQL */ `
  mutation CreateConsignee(
    $input: CreateConsigneeInput!
    $condition: ModelconsigneeConditionInput
  ) {
    createConsignee(input: $input, condition: $condition) {
      id
      name
      address01
      address02
      address03
      address04
      createdAt
      type
      updatedAt
      owner
    }
  }
`;
export const updateConsignee = /* GraphQL */ `
  mutation UpdateConsignee(
    $input: UpdateConsigneeInput!
    $condition: ModelconsigneeConditionInput
  ) {
    updateConsignee(input: $input, condition: $condition) {
      id
      name
      address01
      address02
      address03
      address04
      createdAt
      type
      updatedAt
      owner
    }
  }
`;
export const deleteConsignee = /* GraphQL */ `
  mutation DeleteConsignee(
    $input: DeleteConsigneeInput!
    $condition: ModelconsigneeConditionInput
  ) {
    deleteConsignee(input: $input, condition: $condition) {
      id
      name
      address01
      address02
      address03
      address04
      createdAt
      type
      updatedAt
      owner
    }
  }
`;
export const createNotify = /* GraphQL */ `
  mutation CreateNotify(
    $input: CreateNotifyInput!
    $condition: ModelnotifyConditionInput
  ) {
    createNotify(input: $input, condition: $condition) {
      id
      name
      address01
      address02
      address03
      address04
      createdAt
      type
      updatedAt
      owner
    }
  }
`;
export const updateNotify = /* GraphQL */ `
  mutation UpdateNotify(
    $input: UpdateNotifyInput!
    $condition: ModelnotifyConditionInput
  ) {
    updateNotify(input: $input, condition: $condition) {
      id
      name
      address01
      address02
      address03
      address04
      createdAt
      type
      updatedAt
      owner
    }
  }
`;
export const deleteNotify = /* GraphQL */ `
  mutation DeleteNotify(
    $input: DeleteNotifyInput!
    $condition: ModelnotifyConditionInput
  ) {
    deleteNotify(input: $input, condition: $condition) {
      id
      name
      address01
      address02
      address03
      address04
      createdAt
      type
      updatedAt
      owner
    }
  }
`;
export const createDeliveryAgent = /* GraphQL */ `
  mutation CreateDeliveryAgent(
    $input: CreateDeliveryAgentInput!
    $condition: ModeldeliveryAgentConditionInput
  ) {
    createDeliveryAgent(input: $input, condition: $condition) {
      id
      name
      address01
      address02
      address03
      address04
      createdAt
      type
      updatedAt
      owner
    }
  }
`;
export const updateDeliveryAgent = /* GraphQL */ `
  mutation UpdateDeliveryAgent(
    $input: UpdateDeliveryAgentInput!
    $condition: ModeldeliveryAgentConditionInput
  ) {
    updateDeliveryAgent(input: $input, condition: $condition) {
      id
      name
      address01
      address02
      address03
      address04
      createdAt
      type
      updatedAt
      owner
    }
  }
`;
export const deleteDeliveryAgent = /* GraphQL */ `
  mutation DeleteDeliveryAgent(
    $input: DeleteDeliveryAgentInput!
    $condition: ModeldeliveryAgentConditionInput
  ) {
    deleteDeliveryAgent(input: $input, condition: $condition) {
      id
      name
      address01
      address02
      address03
      address04
      createdAt
      type
      updatedAt
      owner
    }
  }
`;
export const createPort = /* GraphQL */ `
  mutation CreatePort(
    $input: CreatePortInput!
    $condition: ModelportConditionInput
  ) {
    createPort(input: $input, condition: $condition) {
      id
      name
      createdAt
      updatedAt
      owner
    }
  }
`;
export const updatePort = /* GraphQL */ `
  mutation UpdatePort(
    $input: UpdatePortInput!
    $condition: ModelportConditionInput
  ) {
    updatePort(input: $input, condition: $condition) {
      id
      name
      createdAt
      updatedAt
      owner
    }
  }
`;
export const deletePort = /* GraphQL */ `
  mutation DeletePort(
    $input: DeletePortInput!
    $condition: ModelportConditionInput
  ) {
    deletePort(input: $input, condition: $condition) {
      id
      name
      createdAt
      updatedAt
      owner
    }
  }
`;
export const createDestinationPort = /* GraphQL */ `
  mutation CreateDestinationPort(
    $input: CreateDestinationPortInput!
    $condition: ModeldestinationPortConditionInput
  ) {
    createDestinationPort(input: $input, condition: $condition) {
      id
      name
      createdAt
      updatedAt
      owner
    }
  }
`;
export const updateDestinationPort = /* GraphQL */ `
  mutation UpdateDestinationPort(
    $input: UpdateDestinationPortInput!
    $condition: ModeldestinationPortConditionInput
  ) {
    updateDestinationPort(input: $input, condition: $condition) {
      id
      name
      createdAt
      updatedAt
      owner
    }
  }
`;
export const deleteDestinationPort = /* GraphQL */ `
  mutation DeleteDestinationPort(
    $input: DeleteDestinationPortInput!
    $condition: ModeldestinationPortConditionInput
  ) {
    deleteDestinationPort(input: $input, condition: $condition) {
      id
      name
      createdAt
      updatedAt
      owner
    }
  }
`;
export const createAirportCode = /* GraphQL */ `
  mutation CreateAirportCode(
    $input: CreateAirportCodeInput!
    $condition: ModelairportCodeConditionInput
  ) {
    createAirportCode(input: $input, condition: $condition) {
      id
      code
      createdAt
      updatedAt
      owner
    }
  }
`;
export const updateAirportCode = /* GraphQL */ `
  mutation UpdateAirportCode(
    $input: UpdateAirportCodeInput!
    $condition: ModelairportCodeConditionInput
  ) {
    updateAirportCode(input: $input, condition: $condition) {
      id
      code
      createdAt
      updatedAt
      owner
    }
  }
`;
export const deleteAirportCode = /* GraphQL */ `
  mutation DeleteAirportCode(
    $input: DeleteAirportCodeInput!
    $condition: ModelairportCodeConditionInput
  ) {
    deleteAirportCode(input: $input, condition: $condition) {
      id
      code
      createdAt
      updatedAt
      owner
    }
  }
`;
export const createCarrierCode = /* GraphQL */ `
  mutation CreateCarrierCode(
    $input: CreateCarrierCodeInput!
    $condition: ModelcarrierCodeConditionInput
  ) {
    createCarrierCode(input: $input, condition: $condition) {
      id
      code
      createdAt
      updatedAt
      owner
    }
  }
`;
export const updateCarrierCode = /* GraphQL */ `
  mutation UpdateCarrierCode(
    $input: UpdateCarrierCodeInput!
    $condition: ModelcarrierCodeConditionInput
  ) {
    updateCarrierCode(input: $input, condition: $condition) {
      id
      code
      createdAt
      updatedAt
      owner
    }
  }
`;
export const deleteCarrierCode = /* GraphQL */ `
  mutation DeleteCarrierCode(
    $input: DeleteCarrierCodeInput!
    $condition: ModelcarrierCodeConditionInput
  ) {
    deleteCarrierCode(input: $input, condition: $condition) {
      id
      code
      createdAt
      updatedAt
      owner
    }
  }
`;
export const createDestinationAirport = /* GraphQL */ `
  mutation CreateDestinationAirport(
    $input: CreateDestinationAirportInput!
    $condition: ModeldestinationAirportConditionInput
  ) {
    createDestinationAirport(input: $input, condition: $condition) {
      id
      name
      createdAt
      updatedAt
      owner
    }
  }
`;
export const updateDestinationAirport = /* GraphQL */ `
  mutation UpdateDestinationAirport(
    $input: UpdateDestinationAirportInput!
    $condition: ModeldestinationAirportConditionInput
  ) {
    updateDestinationAirport(input: $input, condition: $condition) {
      id
      name
      createdAt
      updatedAt
      owner
    }
  }
`;
export const deleteDestinationAirport = /* GraphQL */ `
  mutation DeleteDestinationAirport(
    $input: DeleteDestinationAirportInput!
    $condition: ModeldestinationAirportConditionInput
  ) {
    deleteDestinationAirport(input: $input, condition: $condition) {
      id
      name
      createdAt
      updatedAt
      owner
    }
  }
`;
export const createAirline = /* GraphQL */ `
  mutation CreateAirline(
    $input: CreateAirlineInput!
    $condition: ModelairlineConditionInput
  ) {
    createAirline(input: $input, condition: $condition) {
      id
      name
      logoUrl
      createdAt
      updatedAt
      owner
    }
  }
`;
export const updateAirline = /* GraphQL */ `
  mutation UpdateAirline(
    $input: UpdateAirlineInput!
    $condition: ModelairlineConditionInput
  ) {
    updateAirline(input: $input, condition: $condition) {
      id
      name
      logoUrl
      createdAt
      updatedAt
      owner
    }
  }
`;
export const deleteAirline = /* GraphQL */ `
  mutation DeleteAirline(
    $input: DeleteAirlineInput!
    $condition: ModelairlineConditionInput
  ) {
    deleteAirline(input: $input, condition: $condition) {
      id
      name
      logoUrl
      createdAt
      updatedAt
      owner
    }
  }
`;
export const createAwb = /* GraphQL */ `
  mutation CreateAwb(
    $input: CreateAwbInput!
    $condition: ModelawbConditionInput
  ) {
    createAwb(input: $input, condition: $condition) {
      id
      url
      awbNumberOne
      awbNumberTwo
      awbNumberThree
      awbNumberFour
      typeOfAWB
      airline
      carrierAgentName
      carrierAgentCity
      iataCode
      accountNo
      airportOfDept
      toOne
      byFirstCarrier
      toTwo
      byOne
      toThree
      byTwo
      airportOfDestination
      accountingInformation
      currency
      chgs
      option
      declaredValueForChange
      declaredValueForCustoms
      amountOfInsurance
      handlingInformation
      chargeableWeight
      rate
      total
      description
      extraDescription
      weightCharge
      valuationCharge
      tax
      dueAgent
      dueCarrier
      totalPrepaid
      totalCollect
      currencyConversionRate
      ccChargesInDestCurrency
      chargesAtDestination
      totalCollectCharges
      otherCharges
      signOfShipper
      executedOn
      place
      createdAt
      updatedAt
      owner
    }
  }
`;
export const updateAwb = /* GraphQL */ `
  mutation UpdateAwb(
    $input: UpdateAwbInput!
    $condition: ModelawbConditionInput
  ) {
    updateAwb(input: $input, condition: $condition) {
      id
      url
      awbNumberOne
      awbNumberTwo
      awbNumberThree
      awbNumberFour
      typeOfAWB
      airline
      carrierAgentName
      carrierAgentCity
      iataCode
      accountNo
      airportOfDept
      toOne
      byFirstCarrier
      toTwo
      byOne
      toThree
      byTwo
      airportOfDestination
      accountingInformation
      currency
      chgs
      option
      declaredValueForChange
      declaredValueForCustoms
      amountOfInsurance
      handlingInformation
      chargeableWeight
      rate
      total
      description
      extraDescription
      weightCharge
      valuationCharge
      tax
      dueAgent
      dueCarrier
      totalPrepaid
      totalCollect
      currencyConversionRate
      ccChargesInDestCurrency
      chargesAtDestination
      totalCollectCharges
      otherCharges
      signOfShipper
      executedOn
      place
      createdAt
      updatedAt
      owner
    }
  }
`;
export const deleteAwb = /* GraphQL */ `
  mutation DeleteAwb(
    $input: DeleteAwbInput!
    $condition: ModelawbConditionInput
  ) {
    deleteAwb(input: $input, condition: $condition) {
      id
      url
      awbNumberOne
      awbNumberTwo
      awbNumberThree
      awbNumberFour
      typeOfAWB
      airline
      carrierAgentName
      carrierAgentCity
      iataCode
      accountNo
      airportOfDept
      toOne
      byFirstCarrier
      toTwo
      byOne
      toThree
      byTwo
      airportOfDestination
      accountingInformation
      currency
      chgs
      option
      declaredValueForChange
      declaredValueForCustoms
      amountOfInsurance
      handlingInformation
      chargeableWeight
      rate
      total
      description
      extraDescription
      weightCharge
      valuationCharge
      tax
      dueAgent
      dueCarrier
      totalPrepaid
      totalCollect
      currencyConversionRate
      ccChargesInDestCurrency
      chargesAtDestination
      totalCollectCharges
      otherCharges
      signOfShipper
      executedOn
      place
      createdAt
      updatedAt
      owner
    }
  }
`;
export const createAccount = /* GraphQL */ `
  mutation CreateAccount(
    $input: CreateAccountInput!
    $condition: ModelaccountConditionInput
  ) {
    createAccount(input: $input, condition: $condition) {
      id
      jobId
      partyNameSales1
      invoiceDateSales1
      invoiceNoSales1
      amountSales1
      partyNameSales2
      invoiceDateSales2
      invoiceNoSales2
      amountSales2
      partyNameCha
      invoiceDateCha
      invoiceNoCha
      amountCha
      partyNameTransport
      invoiceDateTransport
      invoiceNoTransport
      amountTransport
      partyNamePurchase1
      invoiceDatePurchase1
      invoiceNoPurchase1
      amountPurchase1
      partyNamePurchase2
      invoiceDatePurchase2
      invoiceNoPurchase2
      amountPurchase2
      partyNameRebate1
      invoiceDateRebate1
      invoiceNoRebate1
      amountRebate1
      partyNameRebate2
      invoiceDateRebate2
      invoiceNoRebate2
      amountRebate2
      createdAt
      updatedAt
      owner
    }
  }
`;
export const updateAccount = /* GraphQL */ `
  mutation UpdateAccount(
    $input: UpdateAccountInput!
    $condition: ModelaccountConditionInput
  ) {
    updateAccount(input: $input, condition: $condition) {
      id
      jobId
      partyNameSales1
      invoiceDateSales1
      invoiceNoSales1
      amountSales1
      partyNameSales2
      invoiceDateSales2
      invoiceNoSales2
      amountSales2
      partyNameCha
      invoiceDateCha
      invoiceNoCha
      amountCha
      partyNameTransport
      invoiceDateTransport
      invoiceNoTransport
      amountTransport
      partyNamePurchase1
      invoiceDatePurchase1
      invoiceNoPurchase1
      amountPurchase1
      partyNamePurchase2
      invoiceDatePurchase2
      invoiceNoPurchase2
      amountPurchase2
      partyNameRebate1
      invoiceDateRebate1
      invoiceNoRebate1
      amountRebate1
      partyNameRebate2
      invoiceDateRebate2
      invoiceNoRebate2
      amountRebate2
      createdAt
      updatedAt
      owner
    }
  }
`;
export const deleteAccount = /* GraphQL */ `
  mutation DeleteAccount(
    $input: DeleteAccountInput!
    $condition: ModelaccountConditionInput
  ) {
    deleteAccount(input: $input, condition: $condition) {
      id
      jobId
      partyNameSales1
      invoiceDateSales1
      invoiceNoSales1
      amountSales1
      partyNameSales2
      invoiceDateSales2
      invoiceNoSales2
      amountSales2
      partyNameCha
      invoiceDateCha
      invoiceNoCha
      amountCha
      partyNameTransport
      invoiceDateTransport
      invoiceNoTransport
      amountTransport
      partyNamePurchase1
      invoiceDatePurchase1
      invoiceNoPurchase1
      amountPurchase1
      partyNamePurchase2
      invoiceDatePurchase2
      invoiceNoPurchase2
      amountPurchase2
      partyNameRebate1
      invoiceDateRebate1
      invoiceNoRebate1
      amountRebate1
      partyNameRebate2
      invoiceDateRebate2
      invoiceNoRebate2
      amountRebate2
      createdAt
      updatedAt
      owner
    }
  }
`;
